import React from 'react'
import { Link } from 'react-router-dom'
// Import Sidebar
import EventDetailSidebar from './Sidebar'
// Import BigImg
import BigImg from "../../assets/img/causes/details-big.png"
import causesImg from "../../assets/img/causes/details-small-1.png"
import causesImg1 from "../../assets/img/causes/details-small-2.png"





const EventDetailsArea = () => {

  return (
    <>
          <section id="trending_causes_main" class="section_padding">
        <div class="container">
            <div class="row" id="counter">
                <div class="col-lg-8">
                    <div class="details_wrapper_area">
                        <div class="details_big_img">
                            <img src={BigImg} alt="img" />
                        </div>
                        <div class="details_text_wrapper">
                            <Link to="/event" class="tags_noted">#PCFCommunity</Link>
                            <h2>PCF family day — badminton, culture &amp; integration fair</h2>
                            <p>
                                Our largest gathering combines <strong>badminton</strong> exhibitions and fun matches, children’s games,
                                cultural performances, food, and stalls about education and <strong>integration</strong> in Sweden. Open
                                to members, newcomers, and curious neighbours.
                            </p>
                            <p>
                                You can learn about our seasonal <strong>swimming</strong>, <strong>cricket</strong>, and <strong>football</strong> blocks, sign up for
                                hall time, and meet volunteers who run homework help and integration Q&amp;As.
                            </p>
                            <h3>What to bring</h3>
                            <p>
                                Indoor shoes if you want a casual hit on spare courts; outdoor layers if we use grass for
                                taster sessions. Water bottles and sun protection in summer. Full schedule is emailed and
                                posted on News.
                            </p>
                            <ul>
                                <li><i class="fas fa-circle"></i> Junior badminton try-outs and parent-child games.</li>
                                <li><i class="fas fa-circle"></i> Integration info point (school, health basics, local tips).</li>
                                <li><i class="fas fa-circle"></i> First-aid point and lost-child protocol on site.</li>
                                <li><i class="fas fa-circle"></i> Transport and parking info for registered families.</li>
                            </ul>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="details_small_img">
                                        <img src={causesImg} alt="img" />
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="details_small_img">
                                        <img src={causesImg1} alt="img" />
                                    </div>
                                </div>
                            </div>
                            <p>
                                RSVP through the contact form or email info@pcfsweden.se with your family name and number of
                                attendees. We can’t wait to see you there.
                            </p>
                        </div>
                    </div>
                </div>
               <EventDetailSidebar/>
            </div>
        </div>
    </section>
    </>
  )
}

export default EventDetailsArea